import { Pipe, PipeTransform } from '@angular/core';
import { GeofenceCategories } from '@fleet-beat/api';
import { SelectOption } from '@fleet-beat/core';

@Pipe({
  name: 'geofenceTypePipe',
})
export class GeofenceTypePipe implements PipeTransform {
  transform(value: unknown): string | null {
    if (!value) return null;
    return GeofenceCategories.find((geo: SelectOption) => geo.value === value).label || '-';
  }
}
